import http from "./utils";
import { prefix } from './constants';

// 获取Dau数据
export const getTrendsDauInfo: (payload: any) => Promise<any> | any = (
  payload,
) => {
  return http({
    url: `${prefix}/hot/dau`,
    method: 'post',
    data: payload,
  }) as Promise<any>;
};

// 获取热点页面TotalHeat数据
export const getTrendsTotalHeatInfo: (payload: any) => Promise<any> | any = (
  payload,
) => {
  return http({
    url: `${prefix}/hot/total_heat`,
    method: 'post',
    data: payload,
  }) as Promise<any>;
};

// 获取热点页面列表数据
export const getTrendsHotList: (payload: any) => Promise<any> | any = (
  payload,
) => {
  return http({
    url: `${prefix}/hot/list`,
    method: 'post',
    data: payload,
  }) as Promise<any>;
};

// 获取搜索条件
export const getTrendsCondList: () => Promise<any> | any = () => {
  return http({
    url: `${prefix}/hot/cond`,
    method: 'post',
  }) as Promise<any>;
};

// 获取搜索条件
export const postTrendsUserComment: (payload: any) => Promise<any> | any = (
  payload,
) => {
  return http({
    url: `${prefix}/hot/set_comment_tag`,
    method: 'post',
    data: payload,
  }) as Promise<any>;
};

export const getTrendsDAUDownload: (payload: any) => Promise<any> | any = (
  payload,
) => {
  return http({
    url: `${prefix}/hot/dau_download`,
    method: 'post',
    data: payload,
    responseType: 'arraybuffer',
    responseEncoding: 'utf8',
    rawData: true,
  }) as Promise<any>;
};

export const getTrendsTotalHeatDownload: (
  payload: any,
) => Promise<any> | any = (payload) => {
  return http({
    url: `${prefix}/hot/total_heat_download`,
    method: 'post',
    data: payload,
    responseType: 'arraybuffer',
    responseEncoding: 'utf8',
    rawData: true,
  }) as Promise<any>;
};

export const getTrendsListDownload: (payload: any) => Promise<any> | any = (
  payload,
) => {
  return http({
    url: `${prefix}/hot/list_download`,
    method: 'post',
    data: payload,
    responseType: 'arraybuffer',
    responseEncoding: 'utf8',
    rawData: true,
  }) as Promise<any>;
};
